import diContainer from "../common/di-container";
import { DIContainerKeys } from "../common/di-container/di-container.keys";

const redux = diContainer.resolve(DIContainerKeys.ReduxStore);

const store = redux.store;
const persistor = redux.persistor;

export { store, persistor };
